import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { command, keyBinding, NodeExtension, ExtensionTag, toggleWrap } from '@remirror/core';
import { ExtensionBlockquoteMessages } from '@remirror/messages';
import { wrappingInputRule } from '@remirror/pm/inputrules';

var _dec, _dec2, _class;

/**
 * Add the blockquote block to the editor.
 */
var BlockquoteExtension = (_dec = command({
  icon: 'doubleQuotesL',
  description: _ref => {
    var t = _ref.t;
    return t(ExtensionBlockquoteMessages.DESCRIPTION);
  },
  label: _ref2 => {
    var t = _ref2.t;
    return t(ExtensionBlockquoteMessages.LABEL);
  }
}), _dec2 = keyBinding({
  shortcut: 'Ctrl->',
  command: 'toggleBlockquote'
}), (_class = class BlockquoteExtension extends NodeExtension {
  get name() {
    return 'blockquote';
  }

  createTags() {
    return [ExtensionTag.Block, ExtensionTag.FormattingNode];
  }

  createNodeSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({
      content: 'block+',
      defining: true,
      draggable: false
    }, override), {}, {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'blockquote',
        getAttrs: extra.parse,
        priority: 100
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: node => ['blockquote', extra.dom(node), 0]
    });
  }
  /**
   * Toggle the blockquote for the current block.
   *
   * If none exists one will be created or the existing blockquote content will be
   * lifted out of the blockquote node.
   *
   * ```ts
   * commands.toggleBlockquote();
   * ```
   */


  toggleBlockquote() {
    return toggleWrap(this.type);
  }

  shortcut(props) {
    return this.toggleBlockquote()(props);
  }

  createInputRules() {
    return [wrappingInputRule(/^\s*>\s$/, this.type)];
  }

  createPasteRules() {
    return {
      type: 'node',
      nodeType: this.type,
      regexp: /^\s*>\s$/,
      startOfTextBlock: true
    };
  }

}, (_applyDecoratedDescriptor(_class.prototype, "toggleBlockquote", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "toggleBlockquote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortcut", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "shortcut"), _class.prototype)), _class));

export { BlockquoteExtension };
